export const STORE_USER_INFO = 'STORE_USER_INFO';
export const STORE_CURRENT_CITY = 'STORE_CURRENT_CITY';
export const STORE_SIDEBAR_VISIBLE = 'STORE_SIDEBAR_VISIBLE';
